import React from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import useChangeCheck from "./useChangeCheck";
import ChangeCheckContext from "../support/ChangeCheckContext";

function PasswordInput(props) {

    const { onChange, getStyle } = useChangeCheck(props.onChange);
    const {disable} = React.useContext(ChangeCheckContext)
    const [passwordVisible, setPasswordVisible] = React.useState(false)

    function showPassword(event) {
        setPasswordVisible(event.target.checked)
    }

    function getPasswordInputType() {
        if (passwordVisible) {
            return 'text'
        }
        return 'password'
    }

    return (
        <>
            {props.label ? <Form.Label htmlFor="basic-url">{props.label}</Form.Label> : null}
            <InputGroup className="mb-3">
                <Form.Control disabled={disable} type={getPasswordInputType()} name={props.name} onChange={onChange} value={props.value}
                              style={getStyle()} />
                <Form.Check type="checkbox" style={{marginLeft: '10px'}} label="Ukázať" onChange={showPassword}></Form.Check>
            </InputGroup>
        </>
    )
}

export default PasswordInput
